import m from 'mithril';

/**
 * A column heading with a `?` that explains it.
 *
 * A button rather than a `title` attribute or a bare span: a title tooltip
 * never appears on a phone, and a button takes focus, so a tap shows the
 * bubble and the keyboard reaches it.
 *
 * The bubble hangs below the heading, because the panel clips anything above
 * the table. `anchor` is which way it hangs from there, and the columns on the
 * left of a table have to say `left` — the panel clips past its edges either
 * way, and a bubble hanging left off the first column is half outside it.
 */
export function heading(
    label: string,
    hint: string,
    anchor: 'left' | 'right' = 'right',
) {
    return m('th.numeric', [
        label,
        m(
            'button.hint',
            { type: 'button', 'aria-label': `${label}: ${hint}` },
            [
                '?',
                m(
                    'span.hint__bubble',
                    {
                        class: anchor === 'left' ? 'hint__bubble--left' : '',
                        'aria-hidden': 'true',
                    },
                    hint,
                ),
            ],
        ),
    ]);
}
